import Header from '../layout-components/Header';
import SideBar from '../layout-components/Sidebar';
import MainLayouts from '../BreadCrumb/MainLayOut'
import AppVersionFooter from './AppVersionFooter';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { Footer } from 'antd/es/layout/layout';

const { Content } = Layout;

const MainLayout = () => (
  <Layout style={{ minHeight: '100vh' }}>
       <SideBar />
    <Layout>
      <Header />
      <div style={{ padding: 16}}>
      <MainLayouts />
      </div>
      <Content style={{ margin: '0px 0px 0px' }}>
        <div style={{ padding: 16}}>
          <Outlet />
        </div>
      </Content>
  
      <Footer style={{ background: '#fff', padding: '8px', textAlign: 'right' }}>
        <AppVersionFooter />
      </Footer>
 
    </Layout>
  </Layout>
);

export default MainLayout;
